{
  "title": "Servicios",
  "description": "Gestione sus servicios y haga seguimiento de su rendimiento",
  "create": "Crear servicio",
  "searchPlaceholder": "Buscar servicios...",
  "columns": {
    "status": "Estado",
    "isPaid": "De pago",
    "ratings": "Calificaciones",
    "name": "Nombre",
    "provider": "Proveedor",
    "timeSlots": "Franjas horarias",
    "created": "Creado",
    "order": "Orden",
    "question": "Pregunta",
    "type": "Tipo",
    "required": "Obligatorio"
  },
  "filters": {
    "paid": "De pago",
    "notPaid": "Gratuito",
    "active": "Activo",
    "inactive": "Inactivo"
  },
  "actions": {
    "activate": "Activar",
    "deactivate": "Desactivar",
    "activateSelected": "Activar seleccionados",
    "deleteSelected": "Eliminar seleccionados",
    "exportSelected": "Exportar seleccionados",
    "exporting": "Exportando {{count}} servicios",
    "quickActions": "Acciones rápidas",
    "editService": "Editar servicio",
    "activateService": "Activar servicio",
    "deleteService": "Eliminar servicio",
    "addUnit": "Agregar unidad",
    "createUnit": "Crear unidad",
    "importUnits": "Importar unidades",
    "learnMore": "Más información",
    "editUnit": "Editar unidad",
    "availability": "Disponibilidad",
    "closures": "Cierres",
    "deleteUnit": "Eliminar unidad",
    "addQuestion": "Agregar pregunta",
    "createQuestion": "Crear pregunta",
    "importQuestions": "Importar preguntas",
    "addFirstUnit": "Agregar primera unidad",
    "addFirstQuestion": "Agregar primera pregunta",
    "addProvider": "Agregar proveedor",
    "updateUnit": "Actualizar unidad",
    "addUnitAction": "Agregar unidad",
    "updateQuestion": "Actualizar pregunta",
    "addQuestionAction": "Agregar pregunta"
  },
  "show": {
    "title": "Detalles del servicio",
    "titleWithName": "Servicio {{name}}",
    "documentTitle": "{{name}} | Servicios",
    "loadingDescription": "Cargando detalles del servicio...",
    "tabs": {
      "basicInfo": "Información básica",
      "serviceUnits": "Unidades de servicio",
      "closures": "Cierres",
      "serviceQuestions": "Preguntas del servicio",
      "ratingsReviews": "Calificaciones y reseñas",
      "analytics": "Analítica"
    },
    "basicInfo": {
      "title": "Información básica",
      "description": "Ver información detallada de este servicio",
      "serviceName": "Nombre del servicio",
      "descriptionLabel": "Descripción",
      "noDescription": "Sin descripción disponible",
      "status": "Estado",
      "serviceType": "Tipo de servicio",
      "paidService": "Servicio de pago",
      "freeService": "Servicio gratuito",
      "price": "Precio"
    },
    "ratingsReviews": {
      "title": "Calificaciones y reseñas",
      "description": "Vea calificaciones, reseñas de clientes y todos los servicios prestados por su negocio y proveedores",
      "servicesRendered": "Servicios prestados"
    },
    "analytics": {
      "title": "Analítica del servicio",
      "description": "Información integral sobre el rendimiento de su servicio, reservas y satisfacción del cliente"
    },
    "statusLabels": {
      "active": "Activo",
      "inactive": "Inactivo"
    },
    "ratingStars": {
      "one": "1 estrella",
      "other": "{{count}} estrellas"
    }
  },
  "createPage": {
    "title": "Crear servicio",
    "description": "Siga los pasos a continuación para crear un nuevo servicio",
    "nextCreateService": "Crear servicio",
    "nextAddQuestions": "Agregar preguntas"
  },
  "editPage": {
    "title": "Editar servicio",
    "titleWithName": "Editar servicio {{name}}",
    "description": "Actualizar los detalles de {{name}}",
    "documentTitle": "Editar {{name}}",
    "notFoundTitle": "Servicio no encontrado",
    "notFoundDescription": "No se pudo encontrar el servicio que intenta editar."
  },
  "steps": {
    "basicInfo": {
      "title": "Información básica",
      "createDescription": "Ingrese la información básica de su servicio",
      "editDescription": "Actualice la información básica de su servicio"
    },
    "units": {
      "title": "Unidades de servicio",
      "createDescription": "Agregue unidades para hacer seguimiento de la disponibilidad y asignar proveedores",
      "editDescription": "Gestione unidades y asigne proveedores"
    },
    "questions": {
      "title": "Preguntas del servicio",
      "createDescription": "Cree preguntas para las reservas de clientes",
      "editDescription": "Actualice preguntas para las reservas de clientes"
    },
    "nav": {
      "nextAddUnits": "Siguiente: Agregar unidades",
      "nextAddQuestions": "Siguiente: Agregar preguntas",
      "previousBasicInfo": "Anterior: Información básica",
      "previousServiceUnits": "Anterior: Unidades de servicio",
      "saveChanges": "Guardar cambios"
    }
  },
  "form": {
    "image": "Imagen del servicio",
    "imageDescription": "Suba una imagen para su servicio",
    "uploading": "Subiendo imagen...",
    "name": "Nombre del servicio",
    "nameDescription": "Ingrese un nombre claro y descriptivo para su servicio",
    "namePlaceholder": "Ingrese el nombre del servicio",
    "description": "Descripción del servicio",
    "descriptionHint": "Proporcione una descripción detallada de lo que ofrece su servicio",
    "descriptionPlaceholder": "Describa su servicio",
    "serviceType": "Tipo de servicio",
    "serviceTypeDescription": "Elija si este es un servicio gratuito o de pago",
    "free": "Gratuito",
    "paid": "De pago",
    "price": "Precio (GH₵)",
    "priceDescription": "Establezca el precio de su servicio",
    "pricePlaceholder": "0.00"
  },
  "units": {
    "title": "Unidades de servicio",
    "description": "Gestione y haga seguimiento de unidades de servicio individuales",
    "noProvidersTitle": "Aún no hay proveedores",
    "noProvidersDescription": "Agregue un proveedor de servicio antes de crear unidades. Los proveedores se asignan a cada unidad.",
    "emptyTitle": "Aún no hay unidades de servicio",
    "emptyDescription": "Agregue su primera unidad de servicio para hacer seguimiento de la disponibilidad y asignar proveedores.",
    "emptyTableDescription": "Aún no ha creado ninguna unidad de servicio. Comience creando su primera unidad para hacer seguimiento de la disponibilidad del servicio.",
    "searchPlaceholder": "Buscar unidades...",
    "unknownProvider": "Desconocido",
    "noTimeSlots": "Sin franjas horarias",
    "moreSlots": "+{{count}} más",
    "timeSlotsCount": "{{count}} franjas horarias",
    "timeSlotsConfigured": "{{count}} franjas horarias configuradas",
    "configureTimeSlots": "Configurar franjas horarias",
    "unnamedUnit": "Unidad sin nombre",
    "defaultUnitName": "Unidad",
    "dialog": {
      "addTitle": "Agregar unidad de servicio",
      "editTitle": "Editar unidad de servicio",
      "addDescription": "Cree una nueva unidad de servicio con proveedor y franjas horarias.",
      "editDescription": "Actualice los detalles de la unidad de servicio.",
      "configureDescription": "Configure los detalles de la unidad y el horario de disponibilidad.",
      "unitName": "Nombre de la unidad",
      "unitNameDescription": "Ingrese un nombre descriptivo para esta unidad de servicio",
      "unitNameDescriptionShort": "Ingrese un nombre para esta unidad de servicio",
      "unitNamePlaceholder": "Ingrese el nombre de la unidad",
      "provider": "Proveedor de servicio",
      "providerDescription": "Seleccione el proveedor que atenderá esta unidad",
      "providerDescriptionShort": "Seleccione quién prestará este servicio",
      "providerPlaceholder": "Seleccionar un proveedor",
      "noProvidersAvailable": "No hay proveedores disponibles — agregue uno en Proveedores de servicio",
      "timeSlots": "Franjas horarias",
      "timeSlotsDescription": "Configure cuándo esta unidad está disponible para reservas",
      "timeSlotsDescriptionShort": "Configure la disponibilidad de esta unidad",
      "creating": "Creando...",
      "updating": "Actualizando..."
    }
  },
  "questions": {
    "title": "Preguntas del servicio",
    "description": "Gestione preguntas para reservas de servicios",
    "emptyTitle": "Aún no hay preguntas",
    "emptyDescription": "Agregue preguntas para recopilar información de los clientes durante la reserva.",
    "emptyTableTitle": "Aún no hay preguntas del servicio",
    "emptyTableDescription": "Aún no ha creado ninguna pregunta del servicio. Comience creando su primera pregunta para recopilar información de los clientes durante la reserva.",
    "searchPlaceholder": "Buscar preguntas...",
    "optionsCount": "{{count}} opciones",
    "optional": "Opcional",
    "requiredBadge": "Obligatorio",
    "dialog": {
      "addTitle": "Agregar pregunta",
      "editTitle": "Editar pregunta",
      "description": "Configure los detalles y el tipo de la pregunta.",
      "questionText": "Texto de la pregunta",
      "questionTextDescription": "Ingrese la pregunta que desea hacer a los clientes",
      "questionTextPlaceholder": "Ingrese su pregunta",
      "questionType": "Tipo de pregunta",
      "questionTypeDescription": "Elija cómo responderán los clientes a esta pregunta",
      "answerOptions": "Opciones de respuesta",
      "answerOptionsDescription": "Agregue las opciones disponibles para esta pregunta",
      "optionPlaceholder": "Opción {{number}}",
      "addOption": "Agregar opción",
      "requiredQuestion": "Pregunta obligatoria",
      "requiredQuestionDescription": "Haga obligatoria esta pregunta para que los clientes la respondan"
    },
    "types": {
      "text": "Texto corto",
      "textarea": "Texto largo",
      "select": "Lista desplegable",
      "radio": "Opción múltiple",
      "checkbox": "Casillas de verificación",
      "date": "Fecha",
      "time": "Hora"
    }
  },
  "closures": {
    "add": "Agregar",
    "title": "Cierres y días especiales",
    "description": "Gestione fechas de cierre del servicio y días con horarios personalizados. Se aplican a todas las unidades de servicio a menos que una unidad tenga su propio cierre.",
    "blockedDays": {
      "title": "Días bloqueados (cerrado)",
      "description": "Fechas en las que este servicio está completamente cerrado para todas las unidades.",
      "emptyTitle": "Sin días bloqueados",
      "emptyDescription": "Agregue fechas en las que este servicio estará cerrado para los clientes.",
      "add": "Agregar día bloqueado",
      "dialogTitle": "Agregar día bloqueado",
      "dialogDescription": "Los clientes no podrán reservar este servicio en la fecha seleccionada.",
      "reasonOptional": "Motivo (opcional)",
      "reasonPlaceholder": "Día festivo",
      "removeAriaLabel": "Eliminar día bloqueado"
    },
    "specialDays": {
      "title": "Días especiales (horario personalizado)",
      "description": "Fechas con horarios de apertura diferentes al horario habitual.",
      "emptyTitle": "Sin días especiales",
      "emptyDescription": "Agregue fechas con horarios personalizados, como cierre anticipado o horario extendido.",
      "add": "Agregar día especial",
      "dialogTitle": "Agregar día especial",
      "dialogDescription": "Establezca horarios de operación personalizados para una fecha específica en todas las unidades.",
      "opens": "Apertura",
      "closes": "Cierre",
      "reasonPlaceholder": "Cierre anticipado",
      "removeAriaLabel": "Eliminar día especial"
    },
    "unitDialog": {
      "title": "Cierres del proveedor — {{name}}",
      "description": "Bloquee fechas específicas solo para esta unidad de servicio y proveedor.",
      "reasonPlaceholder": "Día libre del proveedor",
      "loading": "Cargando...",
      "noBlockedDays": "Sin días bloqueados"
    },
    "fields": {
      "date": "Fecha"
    }
  },
  "scheduler": {
    "title": "Configurar franjas horarias",
    "description": "Estas franjas se aplican solo a este proveedor. Otros proveedores del mismo servicio son independientes — no asumimos una silla o sala compartida. Use cualquier hora de inicio y fin (por ejemplo 12:00–12:15).",
    "empty": "Aún no hay franjas. Agregue los horarios en los que los clientes pueden reservar con este proveedor.",
    "addSlot": "Agregar franja",
    "done": "Listo",
    "editSlot": "Editar franja horaria",
    "addSlotTitle": "Agregar franja horaria",
    "slotDescription": "Establezca el día y los horarios exactos para esta ventana reservable.",
    "day": "Día",
    "startTime": "Hora de inicio",
    "endTime": "Hora de fin",
    "overlapHint": "Solo se comprueban solapamientos de franjas en esta unidad. Otros proveedores del mismo servicio pueden usar los mismos horarios.",
    "removeSlot": "Eliminar franja",
    "saveSlot": "Guardar franja",
    "editSlotSr": "Editar franja",
    "removeSlotSr": "Eliminar franja",
    "days": {
      "monday": "Lunes",
      "tuesday": "Martes",
      "wednesday": "Miércoles",
      "thursday": "Jueves",
      "friday": "Viernes",
      "saturday": "Sábado",
      "sunday": "Domingo"
    }
  },
  "analytics": {
    "kpi": {
      "totalBookings": "Total de reservas",
      "totalBookingsDescription": "Reservas de todos los tiempos",
      "totalRevenue": "Ingresos totales",
      "totalRevenueDescription": "Ganancias totales",
      "averageRating": "Calificación promedio",
      "averageRatingDescription": "Satisfacción del cliente",
      "fulfillmentRate": "Tasa de cumplimiento",
      "fulfillmentRateDescription": "Tasa de finalización del servicio",
      "changeFromLastPeriod": "{{change}}% respecto al período anterior"
    },
    "charts": {
      "noData": "Sin datos",
      "noDataProvider": "Sin datos",
      "bookingsTimeline": {
        "title": "Línea de tiempo de reservas",
        "description": "Mostrando reservas completadas y canceladas de los últimos 6 meses",
        "trendUp": "Tendencia al alza del {{change}}% este mes",
        "trendDown": "Tendencia a la baja del {{change}}% este mes"
      },
      "appointmentStatus": {
        "title": "Estado de citas",
        "description": "Distribución de estados de citas",
        "totalAppointments": "Total de citas: {{count}}"
      },
      "revenue": {
        "title": "Ingresos",
        "description": "Ingresos a lo largo del tiempo"
      },
      "providerPerformance": {
        "title": "Rendimiento del proveedor",
        "description": "Ingresos y reservas por proveedor",
        "totalRevenueFooter": "Ingresos totales: GH₵{{amount}}"
      },
      "ratingsDistribution": {
        "title": "Distribución de calificaciones",
        "description": "Desglose de calificaciones de clientes",
        "basedOnReviews": "Basado en {{count}} reseñas en total"
      },
      "peakHours": {
        "title": "Horas pico",
        "description": "Horas con más reservas",
        "peakTime": "Hora pico de reservas: {{hour}}"
      },
      "providerBookings": {
        "title": "Reservas por proveedor",
        "description": "Reservas por proveedor",
        "topPerformer": "Mejor rendimiento: {{name}} con {{count}} reservas"
      },
      "providerUtilization": {
        "title": "Utilización del proveedor",
        "description": "Uso de capacidad del proveedor",
        "footer": "Utilización promedio: {{avg}}% | Mayor: {{name}} ({{value}}%)"
      },
      "providerRatings": {
        "title": "Calificaciones del proveedor",
        "description": "Calificaciones promedio por proveedor",
        "footer": "Calificación promedio: {{avg}}/5 | Mejor calificado: {{name}} ({{rating}}/5)"
      },
      "totalRatings": {
        "title": "Total de calificaciones",
        "description": "Todas las calificaciones enviadas",
        "descriptionOverTime": "Calificaciones recibidas a lo largo del tiempo"
      },
      "fulfillmentRate": {
        "title": "Tasa de cumplimiento",
        "description": "Completadas vs total de reservas",
        "descriptionOverTime": "Tasa de finalización del servicio a lo largo del tiempo"
      },
      "labels": {
        "completed": "Completada",
        "cancelled": "Cancelada",
        "pending": "Pendiente",
        "rescheduled": "Reprogramada",
        "revenue": "Ingresos",
        "bookings": "Reservas",
        "rating": "Calificación",
        "utilization": "Utilización",
        "reviews": "Reseñas",
        "fulfillmentRate": "Tasa de cumplimiento"
      }
    }
  },
  "reviews": {
    "averageRating": "Calificación promedio",
    "outOfFive": "de 5.0",
    "totalReviews": "Total de reseñas",
    "customerReviews": "Reseñas de clientes",
    "totalRatings": "Total de calificaciones",
    "individualSubmissions": "Calificaciones individuales enviadas"
  },
  "rendered": {
    "searchPlaceholder": "Buscar servicios prestados...",
    "emptyTitle": "Aún no hay servicios prestados",
    "emptyDescription": "Los servicios prestados por su negocio y proveedores aparecerán aquí.",
    "filters": {
      "all": "Todos",
      "completed": "Completado",
      "pending": "Pendiente",
      "cancelled": "Cancelado"
    },
    "columns": {
      "customer": "Cliente",
      "service": "Servicio",
      "provider": "Proveedor",
      "date": "Fecha",
      "time": "Hora",
      "status": "Estado",
      "rating": "Calificación"
    }
  },
  "validation": {
    "nameRequired": "El nombre del servicio es obligatorio",
    "descriptionRequired": "La descripción del servicio es obligatoria",
    "imageRequired": "La imagen del servicio es obligatoria",
    "priceRequired": "El precio debe ser mayor que 0 para servicios de pago",
    "imageUploadIncomplete": "La carga de la imagen falló o está incompleta. Vuelva a subir la imagen.",
    "unitNameRequired": "Ingrese un nombre para esta unidad de servicio.",
    "providerRequired": "Seleccione un proveedor de servicio para esta unidad.",
    "serviceLoadFailed": "No se pudo cargar este servicio. Actualice la página e inténtelo de nuevo.",
    "businessLoadFailed": "No se pudo cargar su negocio. Actualice la página e inténtelo de nuevo.",
    "atLeastOneUnit": "Agregue al menos una unidad de servicio antes de continuar.",
    "unitTimeslotsRequired": "Agregue franjas horarias para \"{{name}}\".",
    "slotOverlap": "Dos franjas del {{day}} se solapan ({{startA}}–{{endA}} y {{startB}}–{{endB}}). Ajuste los horarios para este proveedor.",
    "singleSlotOverlap": "Esto se solapa con {{start}}–{{end}} el {{day}}. Elija un horario diferente para este proveedor.",
    "invalidTimes": "Ingrese una hora de inicio y fin válidas (HH:MM).",
    "endBeforeStart": "La hora de fin debe ser posterior a la hora de inicio.",
    "overlapsFound": "Dos o más franjas horarias del mismo día se solapan. Cambie los horarios para que este proveedor no esté programado dos veces.",
    "unitNotFound": "No se encontró esta unidad de servicio. Actualice la página e inténtelo de nuevo.",
    "providerNotFound": "No se pudo encontrar el proveedor seleccionado. Elija otro proveedor.",
    "notAProvider": "El usuario seleccionado no es un proveedor de servicio. Elija alguien de su lista de proveedores.",
    "businessNotFound": "No se pudo encontrar el perfil de su negocio. Actualice e inténtelo de nuevo.",
    "serviceNotFound": "No se pudo encontrar este servicio. Actualice la página e inténtelo de nuevo.",
    "serviceNotInBusiness": "Este servicio no pertenece a su negocio.",
    "questionTextRequired": "Ingrese el texto de la pregunta",
    "questionOptionsRequired": "Agregue al menos una opción"
  },
  "toasts": {
    "uploadFailed": "Error al subir la imagen",
    "imageRequired": "La imagen del servicio es obligatoria",
    "imageTooLarge": "La imagen subida es demasiado grande. Intente con un archivo más pequeño (menos de 5 MB).",
    "created": "¡Servicio creado correctamente!",
    "createdFull": "¡Servicio creado correctamente con todos los detalles!",
    "createFailed": "Error al crear el servicio",
    "createUnitsFailed": "Error al crear las unidades de servicio",
    "updated": "¡Servicio actualizado correctamente!",
    "updateFailed": "Error al actualizar el servicio",
    "businessUnknown": "No se pudo determinar el negocio de este servicio",
    "questionsSaveFailed": "No se pudieron guardar las preguntas del servicio. Inténtelo de nuevo.",
    "unitAvailabilityUpdated": "Disponibilidad de la unidad actualizada correctamente",
    "timeslotsSaveFailed": "No se pudieron guardar las franjas horarias. Inténtelo de nuevo.",
    "unitUpdated": "Unidad de servicio actualizada correctamente",
    "unitCreated": "Unidad de servicio creada correctamente",
    "unitUpdateFailed": "No se pudo actualizar esta unidad de servicio. Inténtelo de nuevo.",
    "unitCreateFailed": "No se pudo crear esta unidad de servicio. Inténtelo de nuevo.",
    "unitDeleted": "Unidad eliminada correctamente",
    "unitDeleteFailed": "No se pudo eliminar esta unidad de servicio.",
    "questionUpdated": "Pregunta actualizada correctamente",
    "questionAdded": "Pregunta agregada correctamente",
    "questionDeleted": "Pregunta eliminada correctamente",
    "blockedDayAdded": "Día bloqueado agregado",
    "blockedDayAddFailed": "Error al agregar día bloqueado",
    "specialDayAdded": "Día especial agregado",
    "specialDayAddFailed": "Error al agregar día especial",
    "blockedDayRemoved": "Día bloqueado eliminado",
    "blockedDayRemoveFailed": "Error al eliminar día bloqueado",
    "specialDayRemoved": "Día especial eliminado",
    "specialDayRemoveFailed": "Error al eliminar día especial",
    "providerBlockedDayAdded": "Día bloqueado del proveedor agregado"
  },
  "dialogs": {
    "activateTitle": "Activar servicio",
    "activateTitleBulk": "Activar {{count}} servicios",
    "activateDescription": "¿Está seguro de que desea activar \"{{name}}\"? Será visible para los clientes.",
    "activateDescriptionBulk": "¿Está seguro de que desea activar {{count}} servicios? Serán visibles para los clientes.",
    "activateConfirm": "Activar",
    "activated": "Servicio activado correctamente",
    "activatedBulk": "{{count}} servicios activados correctamente",
    "activateError": "Error al activar el servicio",
    "deactivateTitle": "Desactivar servicio",
    "deactivateTitleBulk": "Desactivar {{count}} servicios",
    "deactivateDescription": "¿Está seguro de que desea desactivar \"{{name}}\"? Ya no será visible para los clientes.",
    "deactivateDescriptionBulk": "¿Está seguro de que desea desactivar {{count}} servicios? Ya no serán visibles para los clientes.",
    "deactivateConfirm": "Desactivar",
    "deactivated": "Servicio desactivado correctamente",
    "deactivatedBulk": "{{count}} servicios desactivados correctamente",
    "deactivateError": "Error al desactivar el servicio",
    "deleteTitle": "Eliminar servicio",
    "deleteTitleBulk": "Eliminar {{count}} servicios",
    "deleteDescription": "¿Está seguro de que desea eliminar \"{{name}}\"? Esta acción no se puede deshacer.",
    "deleteDescriptionBulk": "¿Está seguro de que desea eliminar {{count}} servicios? Esta acción no se puede deshacer.",
    "deleted": "Servicio eliminado correctamente",
    "deletedBulk": "{{count}} servicios eliminados correctamente",
    "deleteError": "Error al eliminar el servicio",
    "passwordRequired": "La contraseña es obligatoria",
    "passwordLabel": "Contraseña",
    "passwordPlaceholder": "Ingrese su contraseña para confirmar"
  }
}
